import {FC} from 'react'
import {Link} from "react-router-dom";
import { bookingFlows } from '../../constants/global'
import findMenuItem from "../../lib/find-menu-item";
import Item from "./Item";

interface Props {
    content: Content
    booking: Booking,
    setBooking: Function
}

const Nav: FC<Props> = ({ content, booking, setBooking }) => {

    if(!content)
        return;

    let menu = [];

    const booking_flow = booking.booking_flow;
    for (let i=0; i<bookingFlows[booking_flow].menu.length-1; i++) {
        menu.push(findMenuItem(bookingFlows[booking_flow].menu[i], content));
    }

    return (
        <div className={'booking-top'}>
            <div className="row booking-banner_nav booking-banner">
                <div className="container">
                    <div className="col col-12">
                        <div className="menu-bokningsflode-container">
                            <ul id="menu-bokningsflode" className="menu">
                                {menu.map((item:ContentPage, i)=>(
                                    <Item key={i} item={item} index={i+1} booking={booking} setBooking={setBooking}/>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Nav
